import React from 'react';
import { motion } from 'framer-motion';
export function SystemIntro() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-149">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-900/10 via-navy-900 to-navy-900 pointer-events-none" data-id="element-150" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-152">
          <h2 className="text-sm font-bold tracking-widest text-gold-500 uppercase mb-4" data-id="element-153">
            Presentando El Sistema
          </h2>
          <h3 className="text-3xl sm:text-5xl font-bold text-white mb-10" data-id="element-154">
            Secretos de Promoción
          </h3>

          <p className="text-xl text-slate-300 leading-relaxed mb-16 max-w-3xl mx-auto font-light" data-id="element-155">
            «Secretos de Promoción: Guía para Afiliados y Coaches» no es otro
            libro de consejos motivacionales. Es el{' '}
            <strong className="text-white font-medium" data-id="element-156">sistema completo</strong>{' '}
            que integra todo lo que necesitas saber para promocionar, vender y
            escalar — sin importar si estás empezando desde cero o si ya llevas
            tiempo sin ver resultados.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 40
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 1
      }} className="relative mx-auto w-full max-w-lg" data-id="element-157">
          <div className="absolute inset-0 bg-gold-500/20 blur-[80px] rounded-full" data-id="element-158" />
          <img src="https://cdn.magicpatterns.com/uploads/nfCS2tLa6bNu9eozKZeLuT/cober2.png" alt="Secretos de Promoción Book Cover" className="relative z-10 w-full h-auto rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10 mx-auto" data-id="element-159" />
        </motion.div>
      </div>
    </section>;
}